import axios from 'axios';
import { API_BASE_URL } from 'constants/ApiConstant';
import { AUTH_TOKEN, REFRESH_TOKEN } from 'constants/AuthConstant';

const axiosInstance = axios.create({
	baseURL: API_BASE_URL + 'v1',
	timeout: 100000,
	headers: {
		'Accept-Language': 'en',
	},
});

axiosInstance.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem(AUTH_TOKEN);
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

axiosInstance.interceptors.response.use(
	(response) => response?.data,
	async function (error) {
		const originalRequest = error.config;

		// If refresh token request itself fails, logout the user
		if (error.response.status === 401 && originalRequest.url.includes('auth/refresh-tokens')) {
			localStorage.clear();
			window.location.href = '/';
			return Promise.reject(error);
		}

		// If access token is expired, attempt refresh
		if (error.response.status === 401 && !originalRequest._retry) {
			originalRequest._retry = true;
			const refreshToken = localStorage.getItem(REFRESH_TOKEN);

			if (!refreshToken) {
				console.log('No refresh token found. Logging out...');
				localStorage.clear();
				window.location.href = '/';
				return Promise.reject(error);
			}

			try {
				const res = await axios.post(`${API_BASE_URL}v1/auth/refresh-tokens`, {
					refreshToken: refreshToken,
				});

				if (res.status === 200) {
					const newAccessToken = res.data.result.access.token;
					localStorage.setItem(AUTH_TOKEN, newAccessToken);
					localStorage.setItem(REFRESH_TOKEN, res.data.result.refresh.token);

					// Update headers for the retried request
					originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

					// Retry the original request with the new token
					return axiosInstance(originalRequest);
				}
			} catch (refreshError) {
				localStorage.clear();
				window.location.href = '/';
				return Promise.reject(refreshError);
			}
		}

		// For other errors, reject as usual
		return Promise.reject(error);
	},
);

export default axiosInstance;
